import merge from 'lodash/merge'
import { DeepPartial } from "lightweight-charts"
import BaseChartSeries from "./baseSeries"
import { ChartCandle, LineBreakSeriesOptions } from "../chart.typings"
import { BLANK_SERIES_ID, lineBreakSeriesOptions } from "../../../assets/constants"
import { deepClone } from '@mui/x-data-grid/utils/utils'
import { LineBreakChart } from "../../../util/specialChartTypes/LineBreakChart"

class LineBreakSeries extends BaseChartSeries<ChartCandle, LineBreakSeriesOptions> {

    addSeriesToChart() {
        return this.chart.chartApi.addCandlestickSeries(this.seriesOptions)
    }

    getDefaultOptions(): LineBreakSeriesOptions {
        return merge(lineBreakSeriesOptions, this.options)
    }

    getPrimaryData(length = 0): ChartCandle[] {
        return length > 0 ? this.data.slice(-length) : this.data;
    }

    _update(candle: ChartCandle, metadata?: Record<string, any>) {
        this.metadata = metadata || {};
        const lastCandle = this.rawData[this.rawData.length - 1];
        if (lastCandle && lastCandle.time === candle.time) {
            this.rawData[this.rawData.length - 1] = candle
        } else {
            this.rawData.push(candle);
        }
        this.updateData(metadata)
    }

    onOptionsUpdate(options: DeepPartial<LineBreakSeriesOptions>): void {
        const { lineCount, projectionDownColor, projectionUpColor, projectionDownBorderColor, projectionUpBorderColor } = options
        if (lineCount !== undefined) {
            this._setData(this.rawData, this.metadata)
            this.chart.refreshNonPrimaryGroups();
            this.chart.checkIfDataRequired();
        }
    }

    _setData(data: ChartCandle[], metadata?: Record<string, any>) {
        this.metadata = metadata || {};
        this.setData(data, metadata)
        this.seriesApi.setData(this.data)
    }

    generateSeriesData(data: ChartCandle[], metadata: Record<string, any> = {}, update = false): ChartCandle[] {
        if (this.config.id === BLANK_SERIES_ID) {
            return data
        }
        const rawData = this.rawData;
        if (rawData.length === 0) return []
        const candlesticks: ChartCandle[] = deepClone(data)
        if ((candlesticks?.length ?? 0) === 0) return [];

        const lbChart = new LineBreakChart({ candles: candlesticks, lineCount: this.seriesOptions.lineCount ?? 3 })
        const lineBreakCandles = lbChart.getCandles() as ChartCandle[]

        return update ? this.data : lineBreakCandles
    }
}

export default LineBreakSeries
